import { Button, Carousel } from 'antd';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { Link } from '@inertiajs/react';

import { LeftOutlined, RightOutlined } from '@ant-design/icons';
interface NewsItems {
    id: number;
    title: { [key: string]: string };
    description: { [key: string]: string };
    image: string;
    slug:string;
}

interface Props {
    news: NewsItems[];
}

export default function OurNews({ news }: Props) {
    const { t, i18n } = useTranslation();

    const CustomArrow = ({ direction, onClick } : any) => {
        const ArrowIcon = direction === 'prev' ? LeftOutlined : RightOutlined;
        return (
          <div
            style={{
              color: 'black',
              fontSize: '24px',
              cursor: 'pointer',
              position: 'absolute',
              top: '40%',
              transform: 'translateY(-50%)',
              zIndex: 1,
              [direction === 'prev' ? 'left' : 'right']: '10px',
            }}
            onClick={onClick}
          >
            <ArrowIcon className='hover:text-custom-dark-blue'/>
          </div>
        );
      };
    return (
        <div className='m-5 py-5 px-8 grid grid-cols-1'>
            <div className='flex items-center justify-start font-bold text-sm lg:text-base dark:text-white my-8'>
                    <p className=" text-custom-dark-blue p-4 text-sm lg:text-base  dark:text-white">
                        {t('sidebar.medicalnews')}
                    </p>

            </div>
            <Carousel
                arrows
                autoplay
                prevArrow={<CustomArrow direction="prev" />}
                nextArrow={<CustomArrow direction="next" />}
                slidesToShow={3}
                slidesToScroll={1}
                responsive={[
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ]}
            >
                {news.length > 0 &&
                    news.map((slider) => (
                        <Link
                        href={route('client.news.show', { locale: i18n.language, slug: slider.slug })}
                        key={slider.id} className='px-1'> {/* Reduced padding here */}
                            <div className='bg-transparent  flex flex-col items-center  rounded-xl overflow-hidden'>

                                <div className='h-64 overflow-hidden rounded-lg'>
                                    <img
                                        src={slider.image}
                                        loading='lazy'
                                        alt={slider.title[i18n.language]}
                                        className='w-full h-full object-center hover:scale-125 duration-200'
                                    />
                                </div>

                                <p className={`text-sm lg:text-base font-bold p-4 text-custom-dark-blue dark:text-black ${i18n.language === 'ar' ? 'text-end' : 'text-start'} font-sans dark:text-white`}>

                                    {slider.title[i18n.language]}
                                </p>
                                <div
                                dir='rtl'
                                className='ql editor !text-custom-dark-blue font-sans font-bold !mb-5 dark:!text-white' dangerouslySetInnerHTML={{__html : slider.description[i18n.language].length > 50 ? `${slider.description[i18n.language].slice(0,60)}` : slider.description[i18n.language]}} />

                            </div>
                        </Link>
                    ))}
            </Carousel>
        </div>
    );
}